import React from 'react';
import { FallenIceCream } from 'src/assets/images';
import HeaderNav from 'src/containers/self-service/header-nav/header-nav';
import useMerchantProfile from 'src/hooks/useMerchantProfile';
import { useHistory } from 'react-router-dom';
import { paymentsDashboardRoute } from 'src/routing/routes';
import { RETRY_ATTEMPT } from 'src/common';

type Props = {
  onRetry: () => void;
  retries: number;
};

export function FailedTopUp({ onRetry, retries }: Props) {
  const { merchant } = useMerchantProfile();
  const history = useHistory();

  return (
    <section>
      <HeaderNav
        title={merchant?.companyName ? `Hi, welcome back ${merchant?.companyName}` : ''}
        screenName="Business Cash Advance Top-up"
      >
        <section className="mt-32 md:px-96 flex flex-col gap-10 justify-center items-center">
          <img className="w-64" src={FallenIceCream} alt="Rocket image" />
          <h1 className="md:text-4xl text-3xl font-medium text-center">
            Unfortunately we could not process your application. Please retry.
          </h1>
          <button
            onClick={() => {
              if (retries >= RETRY_ATTEMPT) {
                return history.push(paymentsDashboardRoute);
              }
              onRetry();
            }}
            className="bg-red-600 w-40 rounded-full py-3 text-white text-sm font-medium"
          >
            {retries < RETRY_ATTEMPT ? 'Retry' : 'Exit'}
          </button>
        </section>
      </HeaderNav>
    </section>
  );
}
